import CourseBuilder from "@/components/admin/lesson-builder/CourseBuilder";
import { useSearchParams } from "react-router-dom";

export default function InteractiveCourseBuilderPage() {
  const [searchParams] = useSearchParams();
  const course = searchParams.get("course");
  const parsed = course ? Number(course) : NaN;
  const initialCourseId = Number.isFinite(parsed) ? parsed : null;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Course builder</h1>
        <p className="mt-1 text-sm text-slate-500">
          {"Create an interactive course and author each lesson's blocks."}
        </p>
      </div>
      <CourseBuilder initialCourseId={initialCourseId} />
    </div>
  );
}

